import React, {useCallback, useEffect, useRef, useState} from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {Col, Container, Card, CardImg, CardBody, CardTitle, CardText, Row, Button, CardFooter} from 'reactstrap';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import {faChevronLeft} from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-light-svg-icons/faChevronRight';
import {faSignalStream} from '@fortawesome/pro-solid-svg-icons/faSignalStream';

const CarouselV3 = ({
  cards,
  darkText = false,
  fullWidth = false,
  handleNav,
  description,
  noDescription = false,
  noMetadata = false,
  noSubtitle = false,
  linkTo,
  title,
  variant,
  onReplay = [],
  live = [],
  premieresText = 'Premieres'
}) => {
  const containerUlRef = useRef(null);
  const [prevDisabled, setPrevDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);
  const onCarouselScroll = useCallback(el => {
    const carousel = el?.currentTarget ?? containerUlRef.current;
    if (!carousel || !carousel.firstChild || !carousel.lastChild) return;
    const {left, right} = carousel.getBoundingClientRect();
    setPrevDisabled(left <= carousel.firstChild.getBoundingClientRect().left);
    setNextDisabled(right >= carousel.lastChild.getBoundingClientRect().right);
  }, []);
  console.log('LIVE', live);
  const page = useCallback((dir = 'right') => {
    const el = containerUlRef.current;
    if (el === null || typeof el === 'undefined') return;
    //get the bounds of the wrapper
    const boundingBox = el.getBoundingClientRect();
    const bounds = dir === 'right' ? boundingBox.right : boundingBox.left;
    //find the first element that is partially or fully in the bounds
    const nextEl = Array.from(el.children).find(c =>
      dir == 'right' ? c.getBoundingClientRect().right > bounds : c.getBoundingClientRect().left < bounds
    );
    if (nextEl === null || typeof nextEl === 'undefined') return;
    //scroll to that element
    nextEl.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  }, containerUlRef);
  const prevPage = useCallback(() => page('left'));
  const nextPage = useCallback(() => page('right'));
  /*
  useEffect(() => {
    const liveOrReplay = [...onReplay, ...live];
    const el = containerUlRef.current;
    if (el === null || typeof el === 'undefined' || liveOrReplay.length === 0) return;
    const minIndex = cards.reduce((acc, c, idx) => {
      return liveOrReplay.includes(c.id) ? Math.min(acc, idx) : acc;
    }, cards.length - 1);
    console.log('CAROUSEL', live, onReplay, cards.length - 1, minIndex);
    if (minIndex > 0) {
      el.scrollLeft = el.children[minIndex].offsetLeft;
    }
  }, [live, onReplay]);*/

  useEffect(() => {
    onCarouselScroll();
  });

  const header = (
    <h5 className={classNames('text-white d-flex align-items-center mr-3', darkText ? `text-dark` : '')}>
      {title}{' '}
      {linkTo ? (
        <>
          &nbsp; <FontAwesomeIcon icon={faCaretRight} />
        </>
      ) : null}
    </h5>
  );

  return (
    <Container size="2xl" className={classNames('carousel', variant ? `carousel-${variant}` : '')}>
      <Row className={fullWidth ? '' : 'px-sm-5'}>
        <Col>
          {linkTo ? (
            <Link to={linkTo} className="text-small text-white">
              {header}
            </Link>
          ) : (
            header
          )}
          {description ? (
            <p className={classNames('text-white mb-3', darkText ? `text-dark` : '')}>{description}</p>
          ) : null}
        </Col>
      </Row>
      <Row className={classNames('carouselContainer', fullWidth ? '' : 'px-sm-5')}>
        <ul className="carouselNav d-none d-sm-block">
          <li>
            <Button onClick={prevPage} color="link" disabled={prevDisabled} className={`carouselNav-prev`}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
          </li>
          <li>
            <Button onClick={nextPage} color="link" disabled={nextDisabled} className={`carouselNav-next`}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </li>
        </ul>
        <Col xs="auto">
          <ul ref={containerUlRef} onScroll={onCarouselScroll}>
            {cards && cards.length
              ? cards.map((card, i) => {
                  const {date, duration, image, subtitle, title, description} = card.displayProps;
                  let durationObject, dateObject;
                  const {id, slug, type, data} = card;
                  if (duration) {
                    durationObject = moment.duration(duration);
                  }
                  if (date) {
                    dateObject = new Date(date);
                  }

                  return (
                    <Card
                      onClick={
                        slug
                          ? () =>
                              handleNav(
                                null,
                                type,
                                type === 'link'
                                  ? data?.url ?? slug
                                  : type === 'zoomMeeting'
                                  ? data?.recordingUrl ?? slug
                                  : slug,
                                null
                              )
                          : null
                      }
                      tag="li"
                      style={{minWidth: 200}}
                    >
                      <CardImg alt={image.alt} src={image.url} top width="100%" />
                      <CardBody>
                        <CardTitle tag="h6">{title}</CardTitle>
                        {!noSubtitle && subtitle ? <CardText className="subtitle">{subtitle}</CardText> : null}
                        {!noDescription && description ? (
                          <CardText className="description">{description}</CardText>
                        ) : null}
                      </CardBody>
                      {!noMetadata && (duration || date) ? (
                        <CardFooter>
                          {live.includes(i) ? (
                            <div style={{color: 'var(--red)', fontWeight: 600}}>
                              <FontAwesomeIcon icon={faSignalStream} />
                              &nbsp; Live Now!
                            </div>
                          ) : null}
                          {!onReplay.includes(i) && !live.includes(i) ? (
                            <>
                              {duration ? (
                                <small className="text-muted mr-2">{`${
                                  durationObject.hours() ? `${durationObject.hours()} hrs ` : ''
                                }${durationObject.minutes()} min${durationObject.minutes() > 1 ? 's' : ''}`}</small>
                              ) : null}
                              {!live.includes(id) && date ? (
                                <small className="text-muted mr-2">
                                  {dateObject > new Date() ? premieresText ? <>{premieresText}&nbsp;</> : '' : null}
                                  {dateObject.toLocaleDateString(undefined, {dateStyle: 'long'})}
                                </small>
                              ) : null}
                            </>
                          ) : null}
                        </CardFooter>
                      ) : null}
                    </Card>
                  );
                })
              : null}
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default CarouselV3;
